import { HeaderButtonVisibility, DealerCode } from "@/types";

export const APP_NAME = "CONTROL CENTER";
export const APP_VERSION = "1.0.0";

// Header Configuration
export const HEADER_CONFIG: HeaderButtonVisibility = {
  isHelpCenter: true,
  isAI: false,
  isNotification: true,
  isDealerLocator: false,
  isProfile: true,
  isWaffleMenu: true,
} as const;

// Dealer Codes
export const DEALER_CODES = [
  "N020",
  "N030",
  "Q300",
  "M450",
  "H510",
  "D100",
] as const;
export const DEALERS: DealerCode[] = [
  { code: "N020", name: "Panel Dealer" },
  { code: "N030", name: "Panel Dealer 2" },
  { code: "Q300", name: "Al-Bahar" },
  { code: "M450", name: "BORUSAN MAKINA" },
  { code: "H510", name: "WESTERN ST. EQ." },
  { code: "D100", name: "Carter Machinery" },
];
export const DEFAULT_DEALER_CODE = "Q300";

// ARIA Labels
export const ARIA_LABELS = {
  EXPAND_SIDEBAR: "Expand sidebar",
  COLLAPSE_SIDEBAR: "Collapse sidebar",
  MAIN_NAVIGATION: "Main navigation",
  SELECT_DEALER: "Select dealer code",
} as const;

// PAL Configuration Constants
// Configuration for numeric data types with suffixes
export const NUMERIC_TYPE_CONFIG: Record<
  string,
  { suffix: string; inputType: "number"; allowDecimal: boolean }
> = {
  integer: { suffix: "", inputType: "number", allowDecimal: false },
  number: { suffix: "", inputType: "number", allowDecimal: false },
  decimal: { suffix: "", inputType: "number", allowDecimal: true },
  double: { suffix: "", inputType: "number", allowDecimal: true },
  float: { suffix: "", inputType: "number", allowDecimal: true },
  percentage: { suffix: "%", inputType: "number", allowDecimal: true },
  years: { suffix: "yrs", inputType: "number", allowDecimal: false },
  year: { suffix: "yrs", inputType: "number", allowDecimal: false },
  months: { suffix: "mos", inputType: "number", allowDecimal: false },
  month: { suffix: "mos", inputType: "number", allowDecimal: false },
  days: { suffix: "days", inputType: "number", allowDecimal: false },
  day: { suffix: "days", inputType: "number", allowDecimal: false },
};

// Data types that support operators
export const TYPES_WITH_OPERATOR = [
  "integer",
  "number",
  "decimal",
  "double",
  "float",
  "percentage",
  "string",
  "years",
  "year",
  "months",
  "month",
  "days",
  "day",
];

// Timing Constants (in milliseconds)
export const TIMING = {
  SUCCESS_MESSAGE_DURATION: 10000, // Auto-dismiss success messages after 10 seconds
  SIMULATION_MIN_DELAY: 1000, // Minimum delay for simulation progress
  SIMULATION_MAX_ADDITIONAL_DELAY: 5000, // Additional random delay for simulation
} as const;
